import hideTooltip from 'rlink-tooltips/actions/hideTooltip';

export default function closeFlyout ({name}) {
  return dispatch => Promise.all([
    dispatch(hideTooltip()),
    dispatch({
      type: 'CLOSE_FLYOUT',
      payload: {name},
    }),
  ]);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/closeFlyout.js